import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Col, Row, Spin, message } from "antd";
import { UserOutlined, LoadingOutlined, ToolOutlined, GlobalOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import loginBack from "../../../assets/image/login-back.png";
import getStart from "../../../assets/image/getStart.png";
import logo from "../../../assets/image/main-logo.png";
import { Link, useNavigate } from "react-router-dom";
import { get_Packegs, get_Plan_Types, SignUp_Action } from "../../../redux/Auth/AuthActions";
import TermsModal from "../login/TermsModal ";
import PrivacyPolicyModal from "../login/PrivacyPolicyModal ";

const SignupPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [rememberMe, setrememberMe] = React.useState(true);
    const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
    const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
    const isLoading = useSelector((state) => state.Auth.isLoading);

    const onFinish = (values) => {
        const data = {
            name: values.fullName,
            email: values.email,
            password: values.password,
            sudoName: values.fullName,
            role: 'admin',
            companyName: values.companyName,
        };
        dispatch(SignUp_Action(data, rememberMe, navigate));
    };

    // Modal
    const showTermsModal = () => setIsTermsModalOpen(true);
    const closeTermsModal = () => setIsTermsModalOpen(false);
    const showPrivacyModal = () => setIsPrivacyModalOpen(true);
    const closePrivacyModal = () => setIsPrivacyModalOpen(false);

    return (
        <>
            <Row
                justify="center"
                align="middle"
                className="loginForm"
                style={{
                    minHeight: "100vh",
                    width: "100%",
                    backgroundImage: `url(${loginBack})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <Col xs={24} lg={4} className="sideBlue">
                    <img src={getStart} alt="" />
                </Col>
                <Col xs={24} lg={8} className="formSide signup">
                    <img src={logo} alt="Convo Bird" />
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{
                            remember: true,
                        }}
                        autoComplete="on"
                        layout="vertical"
                        onFinish={onFinish}
                    >
                        <Row gutter={[24, 8]}>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    name="fullName"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter your full name!",
                                        },
                                    ]}
                                    label={
                                        <span>
                                            <UserOutlined /> Full Name
                                        </span>
                                    }
                                    className="loginLabel"
                                >
                                    <Input placeholder="Full Name" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    name="email"
                                    rules={[
                                        {
                                            type: 'email',
                                            message: 'Please enter valid email!',
                                        },
                                        {
                                            required: true,
                                            message: "Please enter your email!",
                                        },
                                    ]}
                                    label={
                                        <span>
                                            <UserOutlined /> Email Address
                                        </span>
                                    }
                                    className="loginLabel"
                                >
                                    <Input placeholder="Email" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    name="password"
                                    label={
                                        <span>
                                            <ToolOutlined /> Password
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter your password!",
                                        },
                                    ]}
                                    className="loginLabel"
                                >
                                    <Input.Password
                                        style={{
                                            outline: "0",
                                            border: "none",
                                            width: "100%",
                                            maxWidth: "100%",
                                        }}
                                        placeholder="Password"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    name="confirmPassword"
                                    dependencies={['password']}
                                    label={
                                        <span>
                                            <ToolOutlined /> Confim Password
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please confirm your password!",
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Confirm password does not match!'));
                                            },
                                        }),
                                    ]}
                                    className="loginLabel"
                                >
                                    <Input.Password
                                        style={{
                                            outline: "0",
                                            border: "none",
                                            width: "100%",
                                            maxWidth: "100%",
                                        }}
                                        placeholder="Confirm Password"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24} >
                                <Form.Item
                                    name="companyName"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter your company name",
                                        },
                                    ]}
                                    label={
                                        <span>
                                            <GlobalOutlined /> Company Name
                                        </span>
                                    }
                                    className="loginLabel"
                                >
                                    <Input placeholder="Company Name" />
                                </Form.Item>
                            </Col>
                            {/* <Col span={12} ></Col> */}
                        </Row>
                        <div
                            className="login-form-extras"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: "8px 12px",
                            }}
                        >
                            <Form.Item>
                                <Form.Item name="remember" valuePropName="checked" noStyle>
                                    <Checkbox checked={rememberMe} onChange={(e) => setrememberMe(e.target.checked)} >Remember me</Checkbox>
                                </Form.Item>
                            </Form.Item>
                            <p style={{ fontSize: 12, textAlign: "center" }}>Already have an account? <Link to={"/login"}>Login</Link></p>
                        </div>
                        <p className="terms">
                            By clicking Log In. I confirm that I have read and agree to the
                            Userthemes <span onClick={showTermsModal} style={{ cursor: "pointer", textDecoration: "none" }}>
                                Terms & Conditions
                            </span> &  <span onClick={showPrivacyModal} style={{ cursor: "pointer", textDecoration: "none" }}>
                                Privacy Policy
                            </span> and to receive email and updates.
                        </p>
                        <Form.Item>
                            <Button
                                loading={isLoading}
                                disabled={isLoading}
                                type="primary"
                                htmlType="submit"
                                className="login-form-button"
                            >
                                {"Sign Up"}
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
            <TermsModal isVisible={isTermsModalOpen} onClose={closeTermsModal} />
            <PrivacyPolicyModal isVisible={isPrivacyModalOpen} onClose={closePrivacyModal} />
        </>
    );
};

export default SignupPage;
